import React from 'react';

import styles from './notificationsSidebarStyles';

const NotificationsSidebar = ({ changeTab, openTab }) => {
  const getStyle = tabName => styles.tabItem + ` ${openTab === tabName ? styles.highlighted : ''}`;

  return (
    <div>
      <div className={getStyle('all')} onClick={changeTab('all')}>
        All
      </div>
      <div className={getStyle('unread')} onClick={changeTab('unread')}>
        Unread
      </div>
      <div className={getStyle('read')} onClick={changeTab('read')}>
        Read
      </div>
    </div>
  );
};

export default NotificationsSidebar;
